import { ChangeDetectionStrategy, Component } from "@angular/core";

import { TranslatePipe } from "@pipes";

import { AbstractAlertComponent } from "../abstract/abstract-alert.component";

@Component({
  imports: [TranslatePipe],
  templateUrl: "./alert.component.html",
  styleUrls: ["./alert.component.scss"],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class AlertComponent extends AbstractAlertComponent {
  protected sec = 2;

  public set index(_index: number) {
    this.eR.nativeElement.style.transform = `${this.translateY(_index)} translateX(var(--ai-t))`;
  }
}
